// extracted by mini-css-extract-plugin
export default {"container":"style_container__gpBEJ","card":"style_card__b+0hC"};